/**
 * Coordonnées publiques du site vitrine MADA (fiche corrections GTS
 * 2026-09-03, section 2 — « décisions attendues de la direction »).
 *
 * email : tranché le 2026-09-04 (contact@gts224.com, au lieu de
 * entreprise@gts224.com). WhatsApp : 664867959 puis repassé à 614126612 le
 * même jour — valeur actuelle volontaire. `phone` affiche deux numéros
 * (choix du 2026-09-04) ; seul le premier alimente les liens `tel:` via
 * `phoneTelHref`. Adresse toujours en attente de confirmation.
 */
export const SITE_CONTACT = {
  /** Affiché tel quel (texte, peut lister plusieurs numéros). */
  phone: "+224 614 12 66 12 / 621805347",
  /** Numéro utilisé pour les liens tel: — un seul numéro, sans espaces. */
  phoneTelHref: "+224614126612",
  /** Le seul numéro composé par `phoneTelHref`, mis en forme. À préférer à
   *  `phone` là où afficher deux numéros ferait déborder la ligne. */
  phoneDisplay: "+224 614 12 66 12",
  /** Format wa.me : chiffres uniquement, indicatif compris, sans "+". */
  whatsappNumber: "224614126612",
  email: "contact@gts224.com",
  address: "Lambanyi, Ratoma, Conakry",
} as const;

export const GOLDENTECH_URL = "https://gts224.com";

/**
 * Les autres solutions GOLDENTECH (ticket C-03 — pied de page commun), dans
 * l'ordre d'affichage. `description` : libellé court affiché après le nom
 * (même convention que le pied de page uv-gts.com) ; absent quand aucun
 * positionnement public n'est connu — ne pas inventer.
 */
export const GOLDENTECH_PRODUCTS: readonly {
  name: string;
  url: string;
  description?: string;
}[] = [
  { name: "GOLDENTECH", url: GOLDENTECH_URL, description: "Solutions numériques" },
  { name: "LEKKOL", url: "https://lekkol.com", description: "Gestion scolaire" },
  { name: "UV-GTS", url: "https://uv-gts.com", description: "Réseaux d'agences et de distribution" },
  { name: "DOUDHAL", url: "https://doudhal.com" },
];

/** Message pré-rempli des liens WhatsApp des pages publiques (bouton flottant + pied de page). */
export const WHATSAPP_DEMO_MESSAGE = "Bonjour, je souhaite une démo de MADA pour ma clinique.";

/** Lien wa.me avec message pré-rempli, encodé. */
export function whatsappUrl(message: string): string {
  return `https://wa.me/${SITE_CONTACT.whatsappNumber}?text=${encodeURIComponent(message)}`;
}
